/**
 * @ngdoc Controller
 * @name HybridController
 */
import { handleFileDownload } from "@/utils/download";
(function() {
    'use strict';

    angular.module('vrm.core').controller('HybridController', HybridController);

    /**
     * @constructor
     * @ngInject
     */
    function HybridController($log, $timeout, locale, $scope, $stateParams, $state, $q, ApiService, widgetTypeMapping, AdvancedGraphWidgetConfigs, $filter, VrmModalService, vrmNotificationsService, vrmNotificationType) {
        $log.info('HybridController');

        $scope.downloading = false;

        $scope.$watch('downloading', function() {
            if($scope.downloading) {
                $timeout(function () {
                    openDownloadModal();
                }, 10);
            } else {
                $.magnificPopup.close();
            }
        });

        function openDownloadModal() {
            VrmModalService.openDownloadModal($scope);
        }

        locale.ready('common', 'core','datepicker').then(function () {
            function toUTC(date) {
                return date - (date.getTimezoneOffset() * 60000);
            }

            $scope.currencies = [
                { name: locale.getString('common.euro'), sign: '€', code: 'EUR'},
                { name: locale.getString('common.dollar'), sign: '$', code: 'USD' },
                { name: locale.getString('common.pound'), sign: '£', code: 'GBP' },
                { name: locale.getString('common.rand'), sign: 'R', code: 'ZAR' }
            ];

            function findCurrency(code) {
                if (code) {
                    let currency =  $scope.currencies.find(currency => {
                       return currency.code === code;
                    });
                    if(currency) {
                        return currency;
                    } else {
                        return $scope.currencies[0];
                    }
                }
                return $scope.currencies[0];
            }

            var maxDate = new Date();
            var calc_offset = 0;

            $scope.widgets = [];
            $scope.picker = {
                maxDate: maxDate,
                from: new Date(maxDate.getFullYear(), maxDate.getMonth(), 1).getTime(),
                till: maxDate.getTime(),
                price: 1.00,
                liters: 10,
                currency: findCurrency($stateParams.currency)
            };

            $scope.$watch('installation.id', function(id) {
                if (!id) return;
                ApiService.installations(id, 'report', {'current_state': true}).then(function (response) {
                    let data = response.data.data;
                    if (data.price)
                        $scope.picker.price = data.price;
                        $scope.price = $scope.picker.price;
                    if (data.liters)
                        $scope.picker.liters = data.liters;
                        $scope.liters = $scope.picker.liters
                    if (data.currency)
                        $scope.picker.currency = findCurrency(data.currency);

                    let activeWidgets = [];
                    if (data.widgets)
                        activeWidgets = data.widgets;

                    ApiService.installations(id, 'active-widgets').then(function(response) {
                        if (response.data.widgets && response.data.widgets instanceof Array)
                        {
                            _.each(response.data.widgets, function(widget) {
                                widget.active = activeWidgets.indexOf(widget.idWidget.toString()) > -1;
                                var code = widget.code;
                                if (typeof widgetTypeMapping[widget.code] !== 'undefined')
                                    code = widgetTypeMapping[widget.code];

                                if (AdvancedGraphWidgetConfigs[code])
                                    $scope.widgets.push(widget);
                            });
                        }
                    });
                });


            });

            $scope.updateHybrid = function (field){
                if ($scope[field] === "null") {
                    $scope[field] = 0;
                    $scope.picker[field] = 0;
                }
                $scope.picker[field] = $scope[field];
            };

            /**
             * Get date range with timezone offset
             * @returns {*}
             */
            $scope.getRange = function() {
                if (!$scope.picker.from || !$scope.picker.till)
                    return false;

                $scope.picker.from.setHours(0);
                $scope.picker.from.setMinutes(0);
                $scope.picker.from.setSeconds(0);
                $scope.picker.from.setMilliseconds(0);
                $scope.picker.till.setHours(23);
                $scope.picker.till.setMinutes(59);
                $scope.picker.till.setSeconds(59);
                $scope.picker.till.setMilliseconds(0);

                return {
                    from: Math.round((toUTC($scope.picker.from) - calc_offset) / 1000),
                    till: Math.round((toUTC($scope.picker.till) - calc_offset) / 1000)
                }
            };

            $scope.$watch('installation.timezone_offset', function(offset) {
                $log.info("Setting offset: "+offset);
                //Update maxdate based on timezone of installation
                if (offset !== null && typeof offset !== "undefined") {
                    var now = new Date();
                    calc_offset = offset * 1000;
                    var maxDate = new Date(now.getTime() + calc_offset + (now.getTimezoneOffset() * 60000));
                    $scope.picker.maxDate.setTime(maxDate.getTime());
                }
            });

            $scope.downloadPdf = function(data) {
                if ($scope.downloading) {
                    locale.ready('advanced').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('advanced.download_pending') });
                    });
                    return;
                }

                // Open the downloading modal
                $scope.downloading = true;

                ApiService.installationDownload($scope.installation.id, 'report', data, true).then(function(response) {
                    let siteDescription = $scope.installation && $scope.installation.name ? $scope.installation.name.toString().replace(/[^a-zA-Z0-9]+/g, "") : "";
                    let dateFormat = 'yyyyMMdd';
                    let start = $filter('date')(data.start * 1000, dateFormat, $scope.installation.timezone);
                    let end = $filter('date')(data.end * 1000, dateFormat, $scope.installation.timezone);

                    const contentType = response.data.type;
                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        locale.ready('reporting').then(function () {
                            vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('reporting.download-error') , timeout: 30000});
                        });
                        $scope.downloading = false;
                    } else {
                        handleFileDownload(
                            response.data,
                            `${siteDescription}_${start}_to_${end}.pdf`
                        );
                        $scope.downloading = false;
                    }
                }, function() {
                    locale.ready('reporting').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('reporting.download-error') , timeout: 30000});
                    });
                    $scope.downloading = false;
                });
            };

            $scope.getData = function() {
                var range = $scope.getRange();
                if (!range) return;

                return {
                    start: range.from,
                    end: range.till,
                    price: $scope.picker.price,
                    liters: $scope.picker.liters,
                    currency: $scope.picker.currency.code
                };
            };

            $scope.downloadReport = function () {
                var data = $scope.getData();
                if(!data) {
                    return;
                }

                var widgets = [];
                _.each(_.filter($scope.widgets, function(widget) {return widget.active}), function(widget) {
                    widgets.push(widget.idWidget);
                });
                data.widgets = widgets.join(',');

                $scope.downloadPdf(data);
            };

            $scope.pickadata = {
                dateOptions: {
                    clear: false,

                    monthsFull: [
                        locale.getString('datepicker.january'),
                        locale.getString('datepicker.februari'),
                        locale.getString('datepicker.march'),
                        locale.getString('datepicker.april'),
                        locale.getString('datepicker.may'),
                        locale.getString('datepicker.juni'),
                        locale.getString('datepicker.july'),
                        locale.getString('datepicker.august'),
                        locale.getString('datepicker.september'),
                        locale.getString('datepicker.october'),
                        locale.getString('datepicker.november'),
                        locale.getString('datepicker.december')
                    ],
                    weekdaysShort: [
                        locale.getString('datepicker.short_sunday'),
                        locale.getString('datepicker.short_monday'),
                        locale.getString('datepicker.short_tuesday'),
                        locale.getString('datepicker.short_wednesday'),
                        locale.getString('datepicker.short_thursday'),
                        locale.getString('datepicker.short_friday'),
                        locale.getString('datepicker.short_saturday')
                    ],
                    today: locale.getString('datepicker.today'),
                    close: locale.getString('datepicker.close'),
                    format: locale.getString('datepicker.format')
                },
                timeOptions: {
                    clear: false,
                    format: 'HH:i'
                }
            };

            $scope.openModal = function() {
                VrmModalService.openReportTemplateModal($scope, function(arg) {
                    if(!arg) {
                        vrmNotificationsService.add({type: vrmNotificationType.ERROR, message: locale.getString('reporting.template_name_required')});
                    } else {
                        var data = $scope.getData();
                        data.report_type = 'hybrid_genset';
                        data.idSite = $stateParams.id;
                        data.name = arg;


                        ApiService.reportTemplates($scope.installation.id, null, data, 'POST').then(response => {
                            if(response.data.errors){
                                switch(response.data.errors.name){
                                    case 'This value is too short. It should have 2 characters or more.':
                                        locale.ready('reporting').then(
                                            vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: locale.getString('reporting.invalid_template_name')
                                        }));
                                        break
                                    case 'reporttemplate.name.must.be.unique.for.installation':
                                        locale.ready('reporting').then(
                                            vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: locale.getString('reporting.unique_report_template_name')
                                        }));
                                        break
                                    default:
                                        vrmNotificationsService.add({
                                            type: vrmNotificationType.ERROR,
                                            message: ApiService.formatErrors(response)
                                        });
                                }
                            }
                            else{
                                vrmNotificationsService.add({type: vrmNotificationType.SUCCESS, message: locale.getString('reporting.template_saved')});
                            }
                        })

                    }
                });
            };
        });
    }
})();
